import { Card, CardContent } from './ui/card';
import { motion } from 'framer-motion';

const STEPS = [
  { n: '1', title: 'PICK YOUR PATH', text: 'Start free in the Telegram community, or apply directly for the Elite private circle if you’re a business owner ready for multiple income sources.' },
  { n: '2', title: 'FOLLOW THE SYSTEM', text: 'Daily signals. Daily breakdowns. Step-by-step lessons on AI startup, memecoin, stock, forex, and fixed-time trading. No guessing — just execute.' },
  { n: '3', title: 'APPLY & EARN', text: 'Implement the playbook, ask the mentors when you’re stuck, use the community for accountability. Start generating income, then scale relentlessly.' },
];

export default function PathToWealth() {
  return (
    <section className="section-pad bg-[hsl(0_0%_4%)]">
      <div className="container-x">
        <div className="mb-5 max-w-3xl">
          <div className="text-[11px] uppercase tracking-[0.22em] text-[hsl(43_92%_56%)] mb-2">How It Works</div>
          <h2 className="font-display uppercase text-3xl sm:text-4xl lg:text-5xl leading-[0.95]">YOUR PATH TO WEALTH.</h2>
        </div>
        <div className="grid gap-4 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.45, delay: i * 0.05 }}
            >
              <Card className="card-surface h-full">
                <CardContent className="p-6 space-y-3">
                  <div className="font-display text-6xl text-[hsl(43_92%_56%)] leading-none">{s.n}</div>
                  <div className="font-display uppercase text-2xl">{s.title}</div>
                  <p className="text-sm text-[hsl(0_0%_82%)] leading-relaxed">{s.text}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
